import { CoralogixRum, type CoralogixDomain } from '@coralogix/browser';
import { getReleaseTag } from '../getReleaseTag';
import type { TelemetryAdapter } from '../types';

export function createCoralogixAdapter(
  applicationName: string,
): TelemetryAdapter {
  return {
    name: 'coralogix',

    init({
      environment,
      appVersion,
      commitSha,
      desktopVersion,
      platform,
      arch,
      coralogixPublicKey,
      coralogixDomain,
    }) {
      if (!coralogixPublicKey) {
        return false;
      }

      if (!coralogixDomain) {
        console.warn(
          'Coralogix adapter can not initialize because missing CORALOGIX_DOMAIN, telemetry will not be enabled!',
        );
        return false;
      }

      CoralogixRum.init({
        public_key: coralogixPublicKey,
        coralogixDomain: coralogixDomain as CoralogixDomain,
        application: applicationName,
        version: appVersion ?? '',
        environment,
        labels: {
          desktopVersion,
          releaseTag: getReleaseTag(commitSha),
          platform,
          arch,
        },
        instrumentations: {
          errors: true,
          fetch: true,
          xhr: true,
          web_vitals: true,
          interactions: true,
          long_tasks: true,
          resources: true,
          custom: true,
        },
        sessionRecordingConfig: {
          enable: true,
          autoStartSessionRecording: true,
          recordConsoleEvents: true,
          maskAllInputs: true,
          maskTextSelector: '*',
        },
      });

      return CoralogixRum.isInited;
    },

    setUser(user) {
      if (!CoralogixRum.isInited) {
        return;
      }

      CoralogixRum.setUserContext({
        user_id: user.userId,
        user_name: user.userName ?? '',
        user_email: user.userEmail,
      });
    },

    teardown() {
      if (!CoralogixRum.isInited) {
        return;
      }

      CoralogixRum.shutdown();
    },
  };
}
